const FtpconfigurationIcon = () => {
  return (
    <svg
      id="Group_9462"
      data-name="Group 9462"
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={25}
      viewBox="0 0 30 25"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5545"
            data-name="Rectangle 5545"
            width={30}
            height={25}
            fill="#707070"
          />
        </clipPath>
      </defs>
      <g id="Group_9461" data-name="Group 9461" clipPath="url(#clip-path)">
        <path
          id="Path_12185"
          data-name="Path 12185"
          d="M27.847,25H2.153A2.472,2.472,0,0,1,0,22.3V2.7A2.471,2.471,0,0,1,2.153,0h9.241l2.691,3.7L27.756,3.58a2.463,2.463,0,0,1,2.168,2.681L30,22.287A2.475,2.475,0,0,1,27.847,25"
          fill="#707070"
        />
      </g>
    </svg>
  )
}

export default FtpconfigurationIcon
